import React, { useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CModal,
  CModalBody,
} from '@coreui/react-pro'
import { UpdateDepositBonusClient } from '../../types'
import { updateDepositBonusClientMounted } from '../../model'

type Props = {
  isVisible: boolean
  onClose: () => void
  clientId: string
}

export const UpdateModal: React.FC<Props> = ({
  isVisible,
  onClose,
  clientId,
}) => {
  const [data, setData] = useState<Omit<UpdateDepositBonusClient, 'id'>>({
    bonusPercent: 0,
    personalBonusComment: '',
  })

  const handleChange = (event: {
    currentTarget: { name: any; value: any }
  }) => {
    const name = event.currentTarget.name
    const value = event.currentTarget.value

    setData((prevState) => ({
      ...prevState,
      [name]: value,
    }))
  }

  return (
    <CModal visible={isVisible} onClose={onClose}>
      <CModalBody>
        <CCol xs={8} className="mb-2">
          <>
            <div>
              <CFormInput
                className="mb-2"
                type="number"
                name="bonusPercent"
                placeholder="Bonus percent"
                label="Bonus percent"
                value={data.bonusPercent}
                onChange={handleChange}
              />
            </div>
            <div>
              <CFormInput
                className="mb-2"
                type="text"
                name="personalBonusComment"
                placeholder="Comment"
                label="Comment"
                value={data.personalBonusComment}
                onChange={handleChange}
              />
            </div>
            <div>
              <CButton
                onClick={() => {
                  if (
                    window.confirm(
                      `Are you sure you wish added bonus to ${clientId}?`,
                    )
                  ) {
                    updateDepositBonusClientMounted({
                      id: clientId,
                      bonusPercent: Number(data.bonusPercent),
                      personalBonusComment: data.personalBonusComment,
                    })
                    onClose()
                  }
                }}
              >
                {/*{loading && (*/}
                {/*  <span className="spinner-border spinner-border-sm"></span>*/}
                {/*)}*/}
                Added bonus
              </CButton>
            </div>
          </>
        </CCol>
      </CModalBody>
    </CModal>
  )
}
